export type EventsSearchField = 'id' | 'cameraName' | 'clientName'

export type ParsedEventsSearchFromUrl = {
  field: EventsSearchField
  value: string
}

function onlyNumbers(value: string) {
  return value.replace(/\D/g, '')
}

export function parseUnifiedEventsSearchParam(search: string): ParsedEventsSearchFromUrl | null {
  const trimmed = search.trim()
  if (!trimmed) return null

  const numbers = onlyNumbers(trimmed)
  if (numbers && numbers === trimmed) {
    return {field: 'id', value: trimmed}
  }

  return {field: 'cameraName', value: trimmed}
}
